import { useConfig } from 'config/use-config';
import { CollectionFilter, FilterConfig } from 'interfaces/collection-filter';
import { CollectionProduct } from 'models/collection/collection';
import { useEffect, useMemo, useState } from 'react';
import { slugify } from 'utils/strings';

const BARF_TAG = 'barf';

/**
 * Filter out applicable tags as filter values for CDP based on collection from filterConfig.tags,
 */
export const useAvailableFilterMap = (
  collectionProduct: CollectionProduct[],
  filterConfig?: FilterConfig
): FilterConfig => {
  const {
    featureFlags: { availabilityBarf },
  } = useConfig();
  const [availableChoices, setAvailableChoices] = useState<FilterConfig>(filterConfig || {});

  const convertedTags = useMemo(() => {
    const slugifyiedTags = collectionProduct
      .map((product) => {
        return product.tags.map((tag) => slugify(tag));
      })
      .flat();
    // return only unique
    return Array.from(new Set(slugifyiedTags));
  }, [collectionProduct]);

  useEffect(() => {
    if (!collectionProduct || collectionProduct.length === 0) {
      setAvailableChoices({});
      return;
    }

    if (!filterConfig) {
      return;
    }

    const allowedTags = availabilityBarf
      ? convertedTags
      : convertedTags.filter((tag) => tag !== BARF_TAG);

    const nextConfig = structuredClone(filterConfig);
    for (const key of Object.keys(nextConfig) as CollectionFilter[]) {
      if (nextConfig[key]) {
        nextConfig[key].tags = nextConfig[key].tags.filter((tag) => allowedTags.includes(tag));
      }
    }

    setAvailableChoices(nextConfig);
  }, [collectionProduct, convertedTags, filterConfig, availabilityBarf]);

  return availableChoices;
};
